module.exports = __webpack_public_path__ + "static/img/activity_banner_1.b3ef09e6.png";